import { useFormContext } from 'react-hook-form';

import { GridColumnConfig } from '../../models/gridCoumnConfig';
import { Service } from '../../models/masters/service';
import { SiTrackGrid } from '../si-track-grid/si-track-grid';
import { UserPermissionName } from '../../models/user-permission-name';
import { State } from '@progress/kendo-data-query';

interface CustomGridCellProps {
  field: string;
}
interface FormGridEditableProps {
  name: string;
  columns: GridColumnConfig[];
  // dataItems: any[];
  dataItemKey: string;
  isLoading?: boolean;
  onGridDataChange?: (data: any[]) => void;
  defaultGroup?: any[];
  customGridCell?: any;
  dataItems?: any[];
  isSaveLayout?: boolean;
  fileTitle: string;
  gridConfigFromApi?:
  | {
    dataState: State | undefined;
    columns: any[] | undefined;
  }
  | undefined;
  handleSearch?: (searchTerm: string) => void;
  handleSaveLayout?: (gridDataState: State, gridColumns: GridColumnConfig[]) => void;
  reorderable?: boolean;
  handleResetLayout?: () => void;
  customGroupHeaderCell?: (props: any) => JSX.Element;
  selectedField?: string;
  isBusy?: any;
}

export const FormGridEditable = ({
  name,
  columns,
  dataItemKey,
  isLoading = false,
  defaultGroup,
  customGridCell,
  dataItems,
  fileTitle,
  gridConfigFromApi,
  handleSaveLayout,
  handleSearch,
  isSaveLayout,
  reorderable,
  handleResetLayout,
  customGroupHeaderCell,
  selectedField,
  isBusy
}: FormGridEditableProps): any => {
  const { setValue, getValues } = useFormContext();

  const handleOnChange = (value: any[]) => {
    setValue(name, value);
  };

  return (
    <div className="form-group">
      <SiTrackGrid
        fileTitle={fileTitle}
        dataItemKey={dataItemKey}
        columns={columns}
        // dataItems={!dataItems ? getValues(name) : dataItems}
        onGridDataChange={handleOnChange}
        defaultGroup={defaultGroup}
        actionPermissions={{
          export: UserPermissionName.DOWNLOAD_GRID,
        }}
        customCell={(field) =>
          customGridCell?.({
            field,
          })
        }
        isBusy={isBusy}
        // -----------------Grid Layout-------
        dataItems={!dataItems ? getValues(name) : dataItems}
        reorderable={reorderable}
        // handleSearch={handleSearch}
        handleSaveLayout={handleSaveLayout}
        isSaveLayout={isSaveLayout}
        gridConfigFromApi={gridConfigFromApi}
        handleResetLayout={handleResetLayout}
        // -----------------Grid Layout-------
        customGroupHeaderCell={customGroupHeaderCell}
        selectedField={selectedField}
      />
    </div>
  );
};
